export default __webpack_public_path__ + "static/media/Manual-de-granos.113cac14.pdf";